import axios from 'axios'

export default {
  ListCombo () {
    return new Promise((resolve, reject) => {
      // Recupera del cache la list de items
      const storage = sessionStorage.getItem('usuario_perfil_itemscombo')

      // Si ya estan los datos en el storage, se retorna de ahi, solo para las paramtétricas
      if (storage)
        resolve(JSON.parse(storage))
      else {
        // realizo el llamado ajax
        const p = axios.get('/api/usuario_perfil/ListCombo')

        p.then(({ data }) => {
          sessionStorage.setItem('usuario_perfil_itemscombo', JSON.stringify(data.recordset))
          resolve(data.recordset)
        }).catch((err) => {
          reject(err)
        })
      }
    })
  },
  List (params) {
    return axios.get('/api/usuario_perfil/List', { params })
  },
  Agregar (params) {
    return axios.post('/api/usuario_perfil', params)
  },
  Modificar (params) {
    return axios.put('/api/usuario_perfil', params)
  },
  Borrar (params) {
    return axios.delete('/api/usuario_perfil', { params })
  }
}
